var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';
import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import { stateNamePrefix as AddBuildingSubWizard } from '../AddBuildingWizard/RouteConfig';

var findBuildingAndLocation = function findBuildingAndLocation(locations, buildingID) {
    for (var i = 0; i < locations.length; i++) {
        var location = locations[i];

        for (var j = 0; j < location.buildings.length; j++) {
            var building = location.buildings[j];

            if (building.publicID === buildingID) {
                return { location: location, building: building };
            }
        }
    }

    throw new Error('Building not found');
};

var EditCoveragesCtrl = function () {
    function EditCoveragesCtrl($rootScope, $q, $rootElement, $filter, $scope, $state, $stateParams, CoverablesService, ModalService, cpDeleteBuildingService, StateUtils, CoveragesUtil) {
        var _this = this;

        _classCallCheck(this, EditCoveragesCtrl);

        $rootElement.scrollTop(0);

        this.cpDeleteBuildingService = cpDeleteBuildingService;
        this.CoverablesService = CoverablesService;
        this.ModalService = ModalService;
        this.$filter = $filter;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.StateUtils = StateUtils;

        this.model = StateUtils.activeDataForState(true).model;
        this.jobID = this.model.quoteID ? this.model.quoteID.value : this.model.jobID.value;

        var locations = this.model.lobData.commercialProperty.coverables.locations.value;

        var _findBuildingAndLocat = findBuildingAndLocation(locations, $stateParams.buildingID),
            location = _findBuildingAndLocat.location,
            building = _findBuildingAndLocat.building;

        this.location = location;
        this.building = building;

        this.CoveragesUtil = CoveragesUtil;
        this.dependentCoverages = CoveragesUtil.getDependentCoverages();
        this.sequencer = CoveragesUtil.getSequencer();

        this.initialCoverages = _.cloneDeep(this.building.coverages);

        this.coveragesLoading = false;
        this.lastOperation = $q.resolve();
        this.onCovChange = this.onCovChange.bind(this);
        this.updateCoverages = this.updateCoverages.bind(this);
        this.goBack = this.goBack.bind(this);
        this.showChangesWarning = true;
        this.stateChangeUnsub = this.$rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            if (_this.showChangesWarning && !_.isEqual(_this.initialCoverages, _this.building.coverages) && (_this.StateUtils.hasState('baseTransactionWizard', toState) || _this.StateUtils.hasState(AddBuildingSubWizard, toState))) {

                event.preventDefault();

                _this.ModalService.showWarning('quoteandbind.cp.Unsaved Changes', 'quoteandbind.cp.Do you want to save your changes?', undefined, undefined, undefined, _this.$filter('translate')('quoteandbind.cp.No')).result.then(function () {
                    _this.updateCoverages().then(function () {
                        return _this.$state.go(toState, toParams);
                    });
                }).catch(function () {
                    // If the user chooses to discard, go to state
                    _this.resetCoverages().then(function () {
                        _this.$state.go(toState, toParams);
                    });
                });
            }
            _this.stateChangeUnsub(); // Unsubscribe $stateChangeStart listener
        });
    }

    _createClass(EditCoveragesCtrl, [{
        key: 'onCovChange',
        value: function onCovChange(updatedCoverage) {
            return this.updateCoverages(updatedCoverage);
        }
    }, {
        key: 'updateCoverages',
        value: function updateCoverages(updatedCoverage) {
            var _this2 = this;

            var coverages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (coverages) {
                this.building.coverages = coverages;
            }

            this.coveragesLoading = true;
            this.lastOperation = this.sequencer(this.CoverablesService.updateCPBuildingCoverages(this.jobID, this.location.publicID, this.building, SessionUtil.getSessionUUID(this.model)));

            this.lastOperation.then(function (result) {
                _this2.CoveragesUtil.updateCoverages(updatedCoverage, result.coverages, _this2.building.coverages);
            }).catch(function () {
                return _this2.ModalService.showError('quoteandbind.cp.buildingsWizard.EditCoverages.Coverages not saved', 'quoteandbind.cp.Please check for errors and try again');
            }).then(function () {
                _this2.coveragesLoading = false;
            });

            return this.lastOperation;
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            var _this3 = this;

            var areCoveragesUpdated = false;

            if (_.isEqual(this.initialCoverages, this.building.coverages)) {
                return this.goBack(areCoveragesUpdated);
            }

            return this.ModalService.showWarning('quoteandbind.cp.buildingsWizard.EditBuilding.Cancel Changes?', 'quoteandbind.cp.buildingsWizard.EditBuilding.You will lose all the changes', undefined, undefined, undefined, this.$filter('translate')('quoteandbind.cp.No')).result.then(function () {
                return _this3.resetCoverages();
            }).then(function () {
                return _this3.goBack(areCoveragesUpdated);
            });
        }
    }, {
        key: 'save',
        value: function save(form) {
            var _this4 = this;

            if (this.CoveragesUtil.validateForm(form)) {
                var areCoveragesUpdated = true;
                this.updateCoverages().then(function () {
                    return _this4.goBack(areCoveragesUpdated);
                });
            }
        }
    }, {
        key: 'goBack',
        value: function goBack(areCoveragesUpdated) {
            var params = {
                publicID: this.$state.params.buildingID,
                isCoverageOpen: false,
                areCoveragesUpdated: areCoveragesUpdated
            };
            this.showChangesWarning = false;
            this.$state.go('cpBuildingWizardViewBuilding', params);
        }
    }, {
        key: 'deleteBuilding',
        value: function deleteBuilding() {
            this.cpDeleteBuildingService.deleteBuilding(this.model, this.location, this.building);
        }
    }, {
        key: 'resetCoverages',
        value: function resetCoverages() {
            this.initialCoverages.forEach(function (cov) {
                cov.updated = true;
                cov.terms.forEach(function (term) {
                    term.updated = true;
                });
            });
            return this.updateCoverages(null, this.initialCoverages);
        }
    }]);

    return EditCoveragesCtrl;
}();

EditCoveragesCtrl.$inject = ['$rootScope', '$q', '$rootElement', '$filter', '$scope', '$state', '$stateParams', 'qnb.cpCoverablesService', 'ModalService', 'qnb.cpDeleteBuildingService', 'StateUtils', 'CoveragesUtil'];

export default EditCoveragesCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/EditCoverages/EditCoveragesCtrl.js
// module id = 989
// module chunks = 0